/**
 * HelpButton — the Help entry in the desktop header and the mobile top bar (BR-15). Icon-only, named
 * "Help", with aria-pressed mirroring the panel. Rendering it fetches nothing (NFR-PERF-4).
 */

import { CircleHelp } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useHelp } from './HelpProvider';

interface HelpButtonProps {
  /** Distinguishes the header and top-bar instances, which are never both visible. */
  'data-testid': string;
  className?: string;
}

export function HelpButton({ 'data-testid': testId, className }: HelpButtonProps) {
  const { open, togglePanel } = useHelp();

  return (
    <button
      type="button"
      data-testid={testId}
      aria-label="Help"
      aria-pressed={open}
      aria-controls="help-panel"
      onClick={togglePanel}
      className={cn(
        'flex h-11 w-11 shrink-0 items-center justify-center rounded-md text-muted-foreground transition-colors',
        'hover:bg-accent/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        open && 'bg-accent text-foreground ring-2 ring-ring',
        className,
      )}
    >
      <CircleHelp className="h-5 w-5" aria-hidden="true" />
    </button>
  );
}
